import { computed } from 'vue';

interface CurrentUser {
    id?: number;
    permissions?: string[];
    timezone?: string;
    [key: string]: unknown;
}

/**
 * Composable to get the current user from localStorage
 * @returns Object containing currentUser (reactive) and a getter function
 */
export function useCurrentUser() {
    const getCurrentUser = (): CurrentUser | null => {
        const userDataString = localStorage.getItem('playvox-wfm-user');
        return userDataString ? JSON.parse(userDataString) : null;
    };

    const currentUser = computed(() => getCurrentUser());

    return {
        currentUser,
        getCurrentUser
    };
}
